import { Box, CardMedia, Icon, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'
import defaultImage from 'assets/images/default_avatar.png'

const PCompletedEvalList = ({ evaluations, appraisalScore, status }) => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const handleView = (submissionId, evaluationDetails, reviewerDetails, status) => {
    navigate(`/app/performance/appraisal/view-result/${submissionId}`, {
      state: {
        ...state,
        evaluationDetails,
        reviewerDetails,
        status,
        initialTabsValue: 2,
      },
    })
  }

  const checkOverallScore = (score) => {
    switch (true) {
      case score === null:
        return <Typography sx={{ fontStyle: 'italic' }}>N/A</Typography>
      case score <= 1:
        return <Typography>Does not fit in the organisation</Typography>
      case score > 1 && score < 3:
        return <Typography>Require improvement in work attitude</Typography>
      case score >= 3 && score < 4:
        return <Typography>You have a good work attitude</Typography>
      case score >= 4:
        return <Typography>You have positive influence at work</Typography>
      default:
        return <Typography sx={{ fontStyle: 'italic' }}>N/A</Typography>
    }
  }

  return (
    <Box display="flex" gap={3}>
      <Box
        width="65%"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.3,
          borderRadius: '10px',
          overflow: 'hidden',
          marginBottom: 10,
        }}
      >
        {evaluations?.map((e, index) => {
          let reviewers = []

          if (e?.is_external === 0) {
            reviewers.push(
              ...e?.evaluation_detail?.filter((detail) => detail?.roles?.includes('reviewee'))
            )
          }

          if (reviewers.length !== 0 || e?.is_external === 1) {
            return (
              <Box key={index} display="flex" flexDirection="column">
                <Box
                  bgcolor="white.main"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  py={2.5}
                  px={3}
                >
                  <Typography fontWeight="bold" color="dark-text.main">
                    {e?.evaluation_title}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Icon
                      sx={
                        e?.evaluation_total_score
                          ? {
                              color: 'yellow-01.main',
                              fontSize: '20px',
                            }
                          : {
                              color: 'gray-inactive-button.main',
                              fontSize: '20px',
                            }
                      }
                    >
                      workspace_premium
                    </Icon>
                    <Typography width={25} variant="h4">
                      {e?.evaluation_total_score
                        ? Math.round(e?.evaluation_total_score * 50) / 10
                        : '--'}
                    </Typography>

                    {e?.is_external === 0 ? (
                      (reviewers?.length === 1 && reviewers[0]?.has_feedback === 0) ||
                      (reviewers?.length === 1 && reviewers[0]?.feedback !== null) ||
                      reviewers[0]?.reviewee_name === reviewers[0]?.reviewer_name ? (
                        <Typography
                          color="alternate.main"
                          onClick={() => {
                            handleView(reviewers[0]?.submission_id, e, reviewers[0], status)
                          }}
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            width: 80,
                            textAlign: 'right',
                          }}
                        >
                          View
                        </Typography>
                      ) : reviewers?.length === 1 && reviewers[0]?.has_feedback === 1 ? (
                        <Typography
                          color="alternate.main"
                          onClick={() => {
                            handleView(reviewers[0]?.submission_id, e, reviewers[0], status)
                          }}
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            width: 80,
                            textAlign: 'right',
                          }}
                        >
                          View
                        </Typography>
                      ) : (
                        <Box sx={{ width: 80 }} />
                      )
                    ) : (
                      <Box sx={{ width: 80 }} />
                    )}
                  </Box>
                </Box>

                {/* List of form for more than 1 reviewers */}
                {reviewers?.length > 1 && (
                  <Box display="flex" flexDirection="column" bgcolor="white.main" px={3}>
                    {reviewers?.map((r, index) => (
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2.5}
                        key={index}
                      >
                        <Box display="flex" alignItems="center" gap={3}>
                          <CardMedia
                            component="img"
                            sx={{
                              height: 45,
                              width: 45,
                              objectFit: 'cover',
                              borderRadius: '50%',
                            }}
                            src={r?.reviewer_image || defaultImage}
                          />
                          <Box display="flex" flexDirection="column">
                            <Typography noWrap>
                              {!!r?.reviewer_name ? r?.reviewer_name : 'Reviewer ' + (index + 1)}
                            </Typography>
                            <Typography variant="body2" color="light-gray-text.main">
                              {r?.reviewer_department_name}
                            </Typography>
                          </Box>
                        </Box>

                        <Box display="flex" alignItems="center" gap={1}>
                          <Icon
                            sx={
                              r?.score === null
                                ? {
                                    color: 'gray-inactive-button.main',
                                    fontSize: '20px',
                                  }
                                : {
                                    color: 'yellow-01.main',
                                    fontSize: '20px',
                                  }
                            }
                          >
                            workspace_premium
                          </Icon>
                          <Typography width={25} variant="h4">
                            {r?.score === null ? '--' : Math.round(r?.score * 50) / 10}
                          </Typography>
                          {r?.has_feedback === 0 || r?.feedback !== null ? (
                            <Typography
                              color="alternate.main"
                              onClick={() => {
                                handleView(r?.submission_id, e, r, status)
                              }}
                              sx={{
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                width: 80,
                                textAlign: 'right',
                              }}
                            >
                              View
                            </Typography>
                          ) : r?.has_feedback === 1 ? (
                            // <AdxButton
                            //   onClick={() => {handleView(r?.submission_id, e, r)}}
                            // >
                            //   Give feedback
                            // </AdxButton>
                            <Typography
                              color="alternate.main"
                              onClick={() => {
                                handleView(r?.submission_id, e, r, status)
                              }}
                              sx={{
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                width: 80,
                                textAlign: 'right',
                              }}
                            >
                              View
                            </Typography>
                          ) : null}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )
          }
        })}
      </Box>

      {/* Card showing Overall score (Right component) */}
      <Box width="35%">
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          bgcolor="white.main"
          borderRadius="10px"
          p={2.5}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={60}
              height={60}
              borderRadius="50%"
              backgroundColor="light-yellow-01.main"
            >
              <Icon
                sx={{
                  color: 'yellow-01.main',
                  fontSize: '30px',
                }}
              >
                workspace_premium
              </Icon>
            </Box>
            <Box>
              <Typography variant="h2" fontWeight="bold">
                {appraisalScore === null ? '--' : Math.round(appraisalScore * 50) / 10}
              </Typography>
              <Typography color="light-gray-text.main">Overall score</Typography>
            </Box>
          </Box>
          <Box bgcolor="gray-background.main" borderRadius="10px" p={2}>
            {checkOverallScore(Math.round(appraisalScore * 50) / 10)}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PCompletedEvalList
